// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"476":"61b4b8f9","1347":"391ef5b2","5841":"52aaa0ed","6856":"8ee07fc5","9770":"61b4b8f9"}[chunkId] + ".chunk.css";
};